import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../v3/Button/Button';

const container = {
  display: 'flex',
  flexDirection: 'row',
  paddingTop: '5px',
  paddingBottom: '5px',
  justifyContent: 'center',
  marginTop: '25px',
  gap: '5px'
};

const disabledBtnStyle = {
  backgroundColor: '#C9CCD4',
  border: 'none'
};

const leftButtonStyle = {
  color: '#007C92',
  backgroundColor: 'white',
  borderRadius: '0px',
  border: 'none',
  display: 'inline-block',
  width: 'auto'
};

const rightButtonStyle = {
  borderRadius: '50px',
  backgroundColor: '#007C92',
  display: 'inline-block',
  width: 'auto'
};

export const Footer = ({
  leftTitle,
  rightTitle,
  leftCallback,
  rightCallback,
  rightBtnStyle = {},
  containerStyle = {},
  isNextAllowed = true
}) => {

  const btnRightStyle = useMemo(() => ({ ...(!rightCallback ? { ...rightButtonStyle, ...disabledBtnStyle, ...rightBtnStyle } : rightButtonStyle) }), [rightCallback]);
  return (
    <div style={{ ...container, ...containerStyle }}>
      {leftTitle && <Button type='button'
        style={leftButtonStyle}
        onClick={leftCallback || undefined}
        disabled={!leftCallback}
        variant='secondary'
      >
        {leftTitle}
      </Button>}

      {isNextAllowed && (!!rightTitle && <Button
        style={btnRightStyle}
        onClick={rightCallback || undefined}
        disabled={!rightCallback}
        variant='primary'
      >
        {rightTitle}
      </Button>)}
    </div>
  );
};

Footer.propTypes = {
  leftTitle: PropTypes.string,
  rightTitle: PropTypes.string,
  leftCallback: PropTypes.func,
  rightCallback: PropTypes.func,
  rightBtnStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  isNextAllowed: PropTypes.bool
};